import { ReportRow } from "./types";

/**
 * CSV Contract cell. Combined parent rows carry a friendly on-screen label
 * ("N configs combined (reseller)"), but the export lists the actual underlying
 * fixed-fee config ids joined together. Children live only in subRows and are
 * never emitted as their own CSV rows, so the export stays parent-only.
 */
function contractCell(r: ReportRow): string {
  return r.subRows?.length
    ? r.subRows.map((c) => c.fixedFeeId).join(" | ")
    : r.fixedFeeId;
}

function downloadCsv(content: string, filename: string) {
  const blob = new Blob([content], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function exportStCsv(rows: ReportRow[], reportDate: string) {
  const headers = [
    "Report Date: " + reportDate,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Contract Currency",
    "",
    "",
    "",
    "",
    "Functional Currency",
    "",
    "",
    "",
    "",
    "",
  ];
  const colHeaders = [
    "Contract",
    "Company Code",
    "Reseller ID",
    "Issuance Date",
    "Contract End Date",
    "Effort Type",
    "Total Fee",
    "Contract Currency Code",
    "Historical FX Rate",
    "Functional Currency Code",
    "ST Issuance",
    "(+) Reclassifications from LT",
    "(-) Invoices Issued",
    "(-) Write-offs",
    "(=) Ending Balance",
    "ST Issuance",
    "(+) Reclassifications from LT",
    "(-) Invoices Issued",
    "(-) Write-offs",
    "(+/-) FX Revaluation",
    "(=) Ending Balance",
  ];
  const csvRows = [headers.join(","), colHeaders.join(",")];
  for (const r of rows) {
    csvRows.push(
      [
        contractCell(r),
        r.companyCode,
        r.resellerId,
        r.dealStartDate,
        r.dealEndDate,
        r.effortType,
        r.contractPrice.toFixed(2),
        r.currencyCode,
        r.fxRate.toString(),
        r.funcCurrency,
        r.stIssuance.toFixed(2),
        r.cumulativeReclass.toFixed(2),
        (-r.invoicesIssued).toFixed(2),
        "0.00",
        r.stEnding.toFixed(2),
        r.funcStIssuance.toFixed(2),
        r.funcStReclass.toFixed(2),
        (-r.functionalInvoicesIssued).toFixed(2),
        "0.00",
        r.stFxReval.toFixed(2),
        r.funcStEnding.toFixed(2),
      ].join(","),
    );
  }
  downloadCsv(
    csvRows.join("\n"),
    `unbilled-ar-13003-short-term-${reportDate}.csv`,
  );
}

export function exportLtCsv(rows: ReportRow[], reportDate: string) {
  const headers = [
    "Report Date: " + reportDate,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "Contract Currency",
    "",
    "",
    "",
    "Functional Currency",
    "",
    "",
    "",
    "",
  ];
  const colHeaders = [
    "Contract",
    "Company Code",
    "Reseller ID",
    "Issuance Date",
    "Contract End Date",
    "Effort Type",
    "Total Fee",
    "Contract Currency Code",
    "Historical FX Rate",
    "Functional Currency Code",
    "LT Issuance",
    "(-) Reclassifications to ST",
    "(-) Write-offs",
    "(=) Ending Balance",
    "LT Issuance",
    "(-) Reclassifications to ST",
    "(-) Write-offs",
    "(+/-) FX Revaluation",
    "(=) Ending Balance",
  ];
  const csvRows = [headers.join(","), colHeaders.join(",")];
  for (const r of rows) {
    csvRows.push(
      [
        contractCell(r),
        r.companyCode,
        r.resellerId,
        r.dealStartDate,
        r.dealEndDate,
        r.effortType,
        r.contractPrice.toFixed(2),
        r.currencyCode,
        r.fxRate.toString(),
        r.funcCurrency,
        r.ltIssuance.toFixed(2),
        (-r.cumulativeReclass).toFixed(2),
        "0.00",
        r.ltEnding.toFixed(2),
        r.funcLtIssuance.toFixed(2),
        (-r.funcLtReclass).toFixed(2),
        "0.00",
        r.ltFxReval.toFixed(2),
        r.funcLtEnding.toFixed(2),
      ].join(","),
    );
  }
  downloadCsv(
    csvRows.join("\n"),
    `unbilled-ar-18203-long-term-${reportDate}.csv`,
  );
}
